import { routes } from './fornecedores.routes';
import PadFornecedoresListController from "./directory/directory.controller";
import PadFornecedoresDetailsController from "./details/details.controller";
export default angular.module('app.pad.fornecedores', [])
    .config(routes)
    .controller('PadFornecedoresListController', PadFornecedoresListController)
    .controller('PadFornecedoresDetailsController', PadFornecedoresDetailsController)
    .name;
